/********************************************************************
    Truncate element to 150 characters without breaking words
*********************************************************************/

const answers = document.querySelectorAll('.js-text-truncate');

for (const answer of answers) {
  const text = answer.textContent;
  const shortenedText = text.substring(0, text.substring(0, 150).lastIndexOf(' '));

  if (text.length > 150) {
    answer.textContent = shortenedText + ' ...';
  } else {
    answer.textContent = text;
  }
}

/************************************************
    Expanding element
*************************************************/

function expandList() {
    const lists = document.querySelectorAll('.js-expand-link');

    lists.forEach(list => {
        const panel = list.nextElementSibling;

        list.addEventListener('click', function(event) {
            if ((panel.style.maxHeight) || (this.classList.contains('expanded'))) {
                this.setAttribute('aria-expanded','false');
                panel.style.maxHeight = null;
                setTimeout(() => {
                  panel.style.visibility = 'hidden';
                }, 500);
            } else {
                this.setAttribute('aria-expanded','true');
                panel.style.maxHeight = panel.scrollHeight + 'px';
                panel.style.visibility = 'visible';
            }
            this.classList.toggle('expanded');
        });
    });
}
expandList();


/************************************************
    Nested expanding element
*************************************************/

function expandListNested() {
    const lists = document.querySelectorAll('.js-expand-link2');

    lists.forEach(list => {
        const panel = list.nextElementSibling;

        list.addEventListener('click', function(event) {
            if ((panel.style.maxHeight) || (this.classList.contains('expanded'))) {
                this.setAttribute('aria-expanded','false');
                panel.style.maxHeight = null;
                setTimeout(() => {
                  panel.style.visibility = 'hidden';
                }, 500);
            } else {
                this.setAttribute('aria-expanded','true');
                panel.style.maxHeight = '9999px';
                panel.style.visibility = 'visible';
            }
            this.classList.toggle('expanded');
        });
    });
}
expandListNested();


/************************************************
    Detecting and removing empty mapped fields
*************************************************/

function detectEmptyField() {
	var mappedField = document.querySelectorAll('.empty-test');

	mappedField.forEach(function(element) {
		var mappedField = element.textContent.trim();

		if (mappedField === "Default text" || mappedField === "") {
			element.remove();
		}
	});
}
detectEmptyField();


/************************************************
    Moving help texts before input in LFR forms
*************************************************/


(function() {
  const MAX_WAIT_TIME = 20000; // Maximum wait time (in ms) before the interval stops
  const INTERVAL_TIME = 100; // Interval duration (in ms) to check for elements

  let elapsedTime = 0;

  let intervalId = setInterval(() => {
    elapsedTime += INTERVAL_TIME;
    const forms = document.querySelectorAll(".portlet-forms");

    // If no forms are found and the max wait time is reached, stop the interval
    if (forms.length === 0) {
      if (elapsedTime >= MAX_WAIT_TIME) {
        clearInterval(intervalId);
      }
      return;
    }

    // Check if the first form contains any form-group elements
    const inputs = forms[0].querySelectorAll(".form-group");
    if (inputs.length === 0) {
      // If no inputs are found and the max wait time is reached, stop the interval
      if (elapsedTime >= MAX_WAIT_TIME) {
        clearInterval(intervalId);
      }
      return;
    }
      if (document.readyState === "complete") {
        if(forms.length === 0){
          clearInterval(intervalId);
        } else {
          if(inputs.length !== 0) {
            clearInterval(intervalId);
            setTimeout(() => {
                document.querySelectorAll(".form-group").forEach(group => {
                    const label = group.querySelector("label");
                    const feedbackGroup = group.querySelector(".form-feedback-group");

                    if (label && feedbackGroup) {
                        const divsToClone = feedbackGroup.querySelectorAll("div:not(.form-feedback-item)");

                        divsToClone.forEach(div => {
                            const clonedDiv = div.cloneNode(true);
                            div.classList.add("d-none");
                            clonedDiv.classList.add("form-help-text");
                            label.insertAdjacentElement("afterend", clonedDiv);
                        });
                    }
                });
            }, INTERVAL_TIME * 2);
          }
        }
      }
  }, INTERVAL_TIME);
})();


/************************************************
    Declare Accordion class
*************************************************/
class Accordion {
    constructor(domNode, closeOthersCallback = null, allowMultipleOpen = true, enforceOneOpen = false) {
      this.rootEl = domNode;
      this.buttonEl = this.rootEl.querySelector('button[aria-expanded]');

      const controlsId = this.buttonEl.getAttribute('aria-controls');
      this.contentEl = document.getElementById(controlsId);

      this.open = this.buttonEl.getAttribute('aria-expanded') === 'true';

      // Callbacks and configuration
      this.closeOthersCallback = closeOthersCallback;
      this.allowMultipleOpen = allowMultipleOpen;
      this.enforceOneOpen = enforceOneOpen;

      // Add event listener for button click
      this.buttonEl.addEventListener('click', () => this.onButtonClick());
    }

    onButtonClick() {
      if (this.open && this.enforceOneOpen) {
        // If already open and enforceOneOpen is true, do nothing
        return;
      }

      if (!this.allowMultipleOpen && !this.open && this.closeOthersCallback) {
        // Close other accordions in the same set before opening this one
        this.closeOthersCallback();
      }

      // Toggle the current accordion state
      this.toggle(!this.open);
    }

    toggle(open) {
      // Avoid redundant state updates
      if (open === this.open) {
        return;
      }

      // Update internal state and reflect changes in the DOM
      this.open = open;
      if (open) {
        this.buttonEl.setAttribute('aria-expanded','true');
        this.contentEl.style.visibility = 'visible';
      } else {
        this.buttonEl.setAttribute('aria-expanded','false');
        setTimeout(() => {
          this.contentEl.style.visibility = 'hidden';
        }, 350);
      }
    }

    // Public method to explicitly open the accordion
    openAccordion() {
      this.toggle(true);
    }

    // Public method to explicitly close the accordion
    closeAccordion() {
      this.toggle(false);
    }
}

let scriptTimestamp = Date.now();

/************************************************
    Used in React portlet view.jsp files
*************************************************/
const renderReactWidget = (widgetName, elementId, configuration, messages) => {
  const runtimeScriptId = "react-widgets-runtime";
  const widgetScriptId = `react-widgets-${widgetName}`;

  let scriptBaseUrl;

  try {
    const storageKey = "reactWidgetsBaseUrl";
    scriptBaseUrl = sessionStorage.getItem(storageKey) ?? localStorage.getItem(storageKey);
  } catch (error) {
    console.error(error);
  }

  scriptBaseUrl ??= "/o/react-widgets/";

  const element = document.getElementById(elementId);
  element.setAttribute("configuration", JSON.stringify(configuration));
  element.setAttribute("messages", JSON.stringify(messages));
  element.classList.add("react-widget-root"); // this class is used to integrate with liferay css styles

  if (!document.getElementById(runtimeScriptId)) {
      const runtimeScript = document.createElement("script");
      runtimeScript.setAttribute("src", scriptBaseUrl + "runtime.js?t=" + scriptTimestamp);
      runtimeScript.setAttribute("id", runtimeScriptId);
      runtimeScript.setAttribute("defer", true);
      document.head.appendChild(runtimeScript);
  }

  if (!document.getElementById(widgetScriptId)) {
    const widgetScript = document.createElement("script");
    widgetScript.setAttribute("src", scriptBaseUrl + widgetName + ".js?t=" + scriptTimestamp);
    widgetScript.setAttribute("id", widgetScriptId);
    widgetScript.setAttribute("defer", true);
    document.head.appendChild(widgetScript);
  }
}


/**********************************************************
    Switching aria-label according to page language
***********************************************************/

document.addEventListener("DOMContentLoaded", () => {
  // Select all breadcrumb navigation elements on the page
  const breadcrumbNavs = document.querySelectorAll('nav[id*="breadcrumbs"], nav ol.breadcrumb');

  // Check if any breadcrumb navigation exists
  if (breadcrumbNavs.length > 0) {
    // Get the current page language ("cs-CZ" or "en-US")
    const lang = document.documentElement.lang;

    breadcrumbNavs.forEach((breadcrumbNavElement) => {
      // Ensure we are targeting the <nav> element, not just the <ol>
      const navElement = breadcrumbNavElement.tagName === "NAV"
        ? breadcrumbNavElement
        : breadcrumbNavElement.closest("nav");

      if (navElement) {
        if (lang === "cs-CZ") {
          navElement.setAttribute("aria-label", "Drobečková navigace");
        } else if (lang === "en-US") {
          navElement.setAttribute("aria-label", "Breadcrumb");
        } else {
          // Default to English if language is unknown
          navElement.setAttribute("aria-label", "Breadcrumb");
        }
      }
    });
  }
});